'use client';

import { useLocaleStore } from '@eliadmin/core/src/stores/locale-store';

const copy: Record<string, readonly [string, string, string]> = {
  sk: [
    'Načítavam súvisiace produkty…',
    'Súvisiace produkty sa nepodarilo načítať.',
    'Skúsiť znova',
  ],
  cs: [
    'Načítám související produkty…',
    'Související produkty se nepodařilo načíst.',
    'Zkusit znovu',
  ],
  en: ['Loading related products…', 'Related products could not be loaded.', 'Try again'],
};

/** Non-blocking status: accessories and purchase controls remain usable. */
export function RelatedProductsStatus({
  loading,
  error,
  retry,
}: {
  loading: boolean;
  error: boolean;
  retry: () => void;
}) {
  const locale = useLocaleStore(s => s.currentLocale);
  const [pending, failed, again] = copy[locale] ?? copy.en;
  if (!loading && !error) return null;
  return (
    <div className="dlz-body-s py-4 text-[#6B7079]" role="status" aria-live="polite">
      {loading ? (
        pending
      ) : (
        <>
          {failed}{' '}
          <button
            type="button"
            onClick={retry}
            className="ml-2 rounded-sm text-[#D7191F] underline underline-offset-4 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#0F1012]"
          >
            {again}
          </button>
        </>
      )}
    </div>
  );
}
